import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LoadingIcon, Pagination } from '@/components';
import { RouteKeys } from '@/configs';
import { useWeb3Context } from '@/contexts';
import { useMaskBoxesOfLazyQuery, useStatisticQuery } from '@/graphql-hooks';
import { usePermissionGranted } from '@/hooks';
import { MyMaskbox, RequestConnection, RequestSwitchChain } from '@/page-components';
import { useCallback, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './index.module.less';
import { useLocales } from './useLocales';
const PAGE_SIZE = 5;
const EMPTY_LIST = [];
export const MyBoxes = () => {
    const t = useLocales();
    const [fetchBoxesOf, { data: boxesData, loading }] = useMaskBoxesOfLazyQuery({});
    const { providerChainId, isNotSupportedChain, account } = useWeb3Context();
    const { data: statsData } = useStatisticQuery({
        variables: {
            id: account ? account.toLowerCase() : '',
        },
    });
    const total = statsData?.maskboxStatistic?.total || 0;
    const history = useHistory();
    const location = useLocation();
    const page = useMemo(() => {
        const p = new URLSearchParams(location.search).get('page');
        return p ? parseInt(p, 10) : 1;
    }, [location.search]);
    const navToPage = useCallback((page) => {
        history.push(`/my-maskboxes?page=${page}`);
    }, []);
    const permissionGranted = usePermissionGranted();
    useEffect(() => {
        if (!page || !account)
            return;
        fetchBoxesOf({
            variables: {
                skip: (page - 1) * PAGE_SIZE,
                first: PAGE_SIZE,
                account,
            },
        });
    }, [fetchBoxesOf, page, account]);
    if (loading) {
        return (_jsx("div", { className: styles.loadingBox, children: _jsx(LoadingIcon, { size: 50 }) }));
    }
    const maskboxes = boxesData?.maskboxes ?? EMPTY_LIST;
    if (!providerChainId)
        return _jsx(RequestConnection, {});
    if (isNotSupportedChain)
        return _jsx(RequestSwitchChain, {});
    const isEmpty = maskboxes.length === 0 && page === 1;
    return (_jsxs("main", { className: styles.main, children: [_jsxs("header", { className: styles.header, children: [_jsx("h1", { children: t('My MaskBoxes') }), permissionGranted && (_jsx(Button, { colorScheme: "primary", onClick: () => {
                            history.push(RouteKeys.Edit);
                        }, children: t('Create MaskBox') }))] }), isEmpty ? (_jsx("div", { className: styles.empty, children: _jsx("p", { className: styles.text, children: permissionGranted
                        ? t('You haven’t created any mystery box yet.')
                        : t('You are not allowed to create MaskBox.') }) })) : (_jsx("ul", { className: styles.list, children: maskboxes.map((maskbox) => (_jsx("li", { className: styles.item, children: _jsx(MyMaskbox, { boxOnSubgraph: maskbox }) }, maskbox.box_id))) })), _jsx(Pagination, { className: styles.paginaton, page: page, total: total, size: PAGE_SIZE, onChange: navToPage })] }));
};
